import React, { useState } from 'react';
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Box } from '@mui/material';
const ReviewTypeSelector = ({ value, onChange, label = "Type" }) => {
    const [selectedValue, setSelectedValue] = useState(value || '');
    const handleChange = (event) => {
        const newValue = event.target.value;
        setSelectedValue(newValue);
        if (onChange) {
            onChange(newValue);
        }
    };
    return (React.createElement(Box, { className: 'mb-4', sx: { minWidth: 200 } },
        React.createElement(FormControl, { component: "fieldset" },
            React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 2 } },
                React.createElement(FormLabel, { component: "span", sx: {
                        color: 'text.primary',
                        fontWeight: 500,
                        mb: 0,
                        '&.Mui-focused': {
                            color: 'text.primary',
                        }
                    } }, label),
                React.createElement(RadioGroup, { row: true, "aria-labelledby": "type-selector-label", name: "type-selector", value: selectedValue, onChange: handleChange, sx: { gap: 2 } },
                    React.createElement(FormControlLabel, { value: "remote", control: React.createElement(Radio, { size: "small" }), label: "Remote", sx: {
                            '& .MuiFormControlLabel-label': {
                                fontSize: '0.875rem',
                                color: 'text.primary'
                            }
                        } }),
                    React.createElement(FormControlLabel, { value: "in-person", control: React.createElement(Radio, { size: "small" }), label: "In-Person", sx: {
                            '& .MuiFormControlLabel-label': {
                                fontSize: '0.875rem',
                                color: 'text.primary'
                            }
                        } }))))));
};
export default ReviewTypeSelector;
